module.exports = __webpack_public_path__ + "static/media/superHero_02.28ee29df.jpg";